export default __webpack_public_path__ + "static/media/36_TopRightSquares_ZoomOut.2f8283c6.mp4";